export const BASE_URL = '';
export const STUDENTS_URL = '/api/students';
export const TEACHERS_URL = '/api/teachers';
export const SUBJECTS_URL = '/api/subjects';
export const PLANS_URL = '/api/plans';
export const STUDENTQUESTIONS_URL = '/api/studentquestions';
export const TEACHERQUESTIONS_URL = '/api/teacherquestions';
export const TEACHERPAYMENTS_URL = '/api/teacherpayments';
export const COURSES_URL = '/api/courses';

